import { useDiscoveryStore } from '../stores/discovery-store';
import { useEffect } from 'react';

export const useDiscoverySessionRouting = () => {
  const { createSessionMutation, session, sessionQuery, setViewState } = useDiscoveryStore();
  const {
    isError: isCreateSessionError,
    isPending: isCreatingSession,
    isSuccess: isCreateSessionSuccess,
    mutateAsync: createSession,
  } = createSessionMutation;

  useEffect(() => {
    if (sessionQuery.isPending) return;
    if (sessionQuery.isError) {
      setViewState('idle');
      return;
    }
    if (session) {
      setViewState(session.current_search_history_id ? 'chat' : 'idle');
      return;
    }
    if (isCreatingSession) return;
    if (isCreateSessionError || isCreateSessionSuccess) {
      setViewState('idle');
      return;
    }

    void createSession()
      .then(() => setViewState('idle'))
      .catch(() => setViewState('idle'));
  }, [
    createSession,
    isCreateSessionError,
    isCreateSessionSuccess,
    isCreatingSession,
    session,
    sessionQuery.isError,
    sessionQuery.isPending,
    setViewState,
  ]);
};
